<template>
  <div>
    <chartjs-pie-card
      v-if="dataIsNotEmpty"
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <div class="d-flex">
          <div class="card-title diligencePieChartTitle">My Commitment</div>
          <div
          class="d-flex"
            style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
            v-tooltip.top-end="toolTipInfo"
          >
            <img src="static/img/graphInfo.svg" class />
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import {
  vals,
  formatCurrency,
  subsetBackground,
  precisionNumberForamtter,
} from "../../../util";
import { ChartjsPieCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
export default {
  name: "pie-commitment-chart-card",
  components: {
    [ChartjsPieCard.name]: ChartjsPieCard,
  },
  props: {
    cutoutPercentage: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      textCenterLabel: [],
      chartColors: {
        active: "#009DE0",
        ob: "#9358A2",
        exit: "#6D5BA4",
      },
    };
  },
  computed: {
    ...mapGetters("charts", ["commitmentChartData"]),
    ...mapGetters("lpAllocations", ["capitalCallData"]),
    chartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset,
      };
      return data;
    },
    chartOptions() {
      const self = this;
      self.textCenterLabel[0] = {
        text: "Total",
        font: {
          size: "14",
          family: "custom-helvetica-medium,roboto",
        },
        color: "#050505",
      };
      self.textCenterLabel[1] = {
        text: `$${precisionNumberForamtter(
          self.commitmentChartData.totalCommitment
        )}`,
        font: {
          size: "25",
          family: "custom-helvetica-medium,roboto",
        },
        color: "#050505",
      };
      let options = {
        cutoutPercentage: this.cutoutPercentage,
        plugins: {
          doughnutlabel: {
            labels: this.textCenterLabel,
          },
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].toolTip_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return `$${precisionNumberForamtter(value, 1)}`;
            },
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            padding: 25,
          },
        },
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    dataIsNotEmpty() {
      return this.commitmentChartData.totalCommitment;
    },
    toolTipInfo() {
      return "The donut chart here is data collected from the summary section. Taking capital called, uncalled and what was committed. By hovering over the sections you can see what percent of capital has been called so far.";
    },
  },
  methods: {
    createPrimaryDataset() {
      const self = this;
      // only do check if there is data (and it is local)
      if (self.commitmentChartData.totalCommitment < 1) return;
      // do initial calculate for chart data
      let calls =
        self.capitalCallData.length == 1
          ? `${self.capitalCallData.length} Call`
          : `${self.capitalCallData.length} Calls`;
      let labels = [`Called(${calls})`, "UnCalled"];
      let backgroundColors = ["#9358A2", "#6D5BA4"];
      let values = [
        self.commitmentChartData.called,
        self.commitmentChartData.uncalled,
      ];
      let values_p = [
        self.commitmentChartData.called_p,
        self.commitmentChartData.uncalled_p,
      ];
      self.labels = [];
      self.datasets = [];
      self.labels = labels;
      self.datasets.push({
        header_label: labels,
        data: values_p,
        data_value: values,
        backgroundColor: backgroundColors,
        toolTip_label: labels,
      });
    },
  },
  mounted() {
    this.createPrimaryDataset();
  },
  watch: {
    commitmentChartData: {
      handler(newData) {
        if (newData) {
          this.createPrimaryDataset();
        }
      },
    },
  },
};
</script>